// src/directives/lazyLoad.js

//   v-lazy:bg="imageUrl"  v-lazy="imageUrl"
// 1. 抽离独立的初始化函数（关键修复：不再依赖this）
const initLazyLoad = (el, binding) => {
  // 1. 边界处理：如果没有传入图片地址，直接返回
  if (!binding.value) {
    console.warn('懒加载指令：图片地址不能为空');
    // 无URL时强制设置默认占位图
    if (binding.arg === 'bg') {
      el.style.backgroundImage = `url(https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/%E8%87%AA%E5%AE%9A%E4%B9%89/%E9%BB%98%E8%AE%A4%E5%8A%A0%E8%BD%BD%E5%9B%BE%E7%89%87.png)`;
    } else {
      el.src = 'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/%E8%87%AA%E5%AE%9A%E4%B9%89/%E9%BB%98%E8%AE%A4%E5%8A%A0%E8%BD%BD%E5%9B%BE%E7%89%87.png';
    }
    return;
  }

  // 2. 定义加载图片的方法
  const loadImage = () => {
    // 创建新图片对象，先加载图片，避免直接赋值src导致页面闪烁
    const img = new Image();
    img.src = binding.value;

    // 图片加载成功：赋值给真实元素
    img.onload = () => {
      // 判断是否是背景图指令（如 v-lazy:bg）
      if (binding.arg === 'bg') {
        el.style.backgroundImage = `url(${binding.value})`;
      } else {
        el.src = binding.value;
      }
    };

    // 图片加载失败：显示默认占位图
    img.onerror = () => {
      if (binding.arg === 'bg') {
        // 背景图加载失败：设为默认图或空白
        el.style.backgroundImage = `url(https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/%E8%87%AA%E5%AE%9A%E4%B9%89/%E9%BB%98%E8%AE%A4%E5%8A%A0%E8%BD%BD%E5%9B%BE%E7%89%87.png)`;
      } else {
        el.src = 'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/%E8%87%AA%E5%AE%9A%E4%B9%89/%E9%BB%98%E8%AE%A4%E5%8A%A0%E8%BD%BD%E5%9B%BE%E7%89%87.png'; // 替换成你的默认失败图
      }
      console.warn(`懒加载指令：图片加载失败 ${binding.value}`);
    };
  };

  // 3. 兼容性处理：判断浏览器是否支持 IntersectionObserver
  if (!window.IntersectionObserver) {
    // 降级：直接加载图片
    loadImage();
    return;
  }

  // 4. 创建观察者实例，监听元素是否进入视口
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // 元素进入视口
      if (entry.isIntersecting) {
        loadImage();
        // 加载完成后取消监听，避免重复触发
        observer.unobserve(el);
        // 将观察者实例挂载到元素上，便于销毁
        el._lazyObserver = observer;
      }
    });
  }, {
    rootMargin: '100px 0px', // 提前100px加载（优化体验）
    threshold: 0.1 // 元素可见比例达到10%时触发
  });

  // 5. 开始监听目标元素
  observer.observe(el);
  // 将观察者实例挂载到元素上，便于销毁
  el._lazyObserver = observer;
};

export default {
  // 指令绑定到元素且元素插入父节点时触发（核心钩子）
  inserted(el, binding) {
    // 直接调用独立的初始化函数（不再用this）
    initLazyLoad(el, binding);
  },

  // 新增：数据更新时触发（解决更换数据后图片不刷新的核心）
  update(el, binding) {
    // 1. 如果图片地址未变化，无需处理
    if (binding.value === binding.oldValue) return;
    
    // 2. 清理旧状态：销毁旧观察者、重置占位图
    if (el._lazyObserver) {
      el._lazyObserver.unobserve(el);
      el._lazyObserver.disconnect();
      delete el._lazyObserver;
    }

    // 3. 重置元素内容（避免显示旧图片）
    // 区分普通图片和背景图
    if (binding.arg === 'bg') {
      // 背景图重置为空白（或你自定义的加载背景）
      el.style.backgroundImage = 'none';
    } else {
      // 普通图片重置为默认加载图
      el.src = 'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/%E8%87%AA%E5%AE%9A%E4%B9%89/%E9%BB%98%E8%AE%A4%E5%8A%A0%E8%BD%BD%E5%9B%BE%E7%89%87.png';
    }

    // 4. 重新初始化懒加载（加载新图片）
    initLazyLoad(el, binding);
  },

  // 指令与元素解绑时触发（销毁监听，避免内存泄漏）
  unbind(el) {
    if (el._lazyObserver) {
      el._lazyObserver.unobserve(el);
      el._lazyObserver.disconnect();
      delete el._lazyObserver;
    }
  }
};